import intl from 'react-intl-universal';

import { ReducerState } from '@/redux/reducers/reservation/checkOut';
import { PRICE_REG } from '@/config/reg';
import { ValidateSchema, createValidator } from '@/pages/reservation/utils/validator';
import {
  validDetailNotRequire,
  validDetailRequire,
  ReverseResonCodeQT,
} from '@/pages/reservation/roomExchange/helper';

const rentRoomList: (value: ReducerState['rentRoomList']) => void = (value) => {
  const rentList = value || [];

  if (rentList.length) {
    rentList.forEach((item) => {
      const { overtimePriceReceivable } = item;
      if (!overtimePriceReceivable) {
        throw new Error(intl.get('drawer_checkout_error_overtime_price_null'));
      }
      if (!PRICE_REG.test(overtimePriceReceivable)) {
        throw new Error(intl.get('drawer_checkout_error_overtime_price_invalid'));
      }
    });
  }

  return null;
};

const overtimePriceAdjustList: (value: ReducerState['overtimePriceAdjustList']) => void = (
  value,
) => {
  const adjustList = value || [];

  if (adjustList.length) {
    adjustList.forEach((item) => {
      const { adjustReason, adjustRemarks } = item;
      if (!adjustReason) {
        throw new Error(intl.get('drawer_checkout_not_select_reverse_reason'));
      }
      if (adjustReason !== ReverseResonCodeQT) {
        if (validDetailNotRequire(adjustRemarks)) {
          throw new Error(intl.get('bill_credit_please_input_carefully'));
        }
      } else {
        if (!adjustRemarks || adjustRemarks.trim().length === 0) {
          throw new Error(intl.get('drawer_checkout_not_input_reverse_remarks'));
        }
        if (validDetailRequire(adjustRemarks)) {
          throw new Error(intl.get('bill_credit_please_input_carefully'));
        }
      }
    });
  }

  return null;
};

const mainSchema: ValidateSchema<ReducerState> = {
  rentRoomList,
  overtimePriceAdjustList,
};

export default createValidator<ReducerState>(mainSchema);
